import type { ModalPortalStyles } from './tooltip-portal-comp.types';
import useDarkMode from 'use-dark-mode';

import { getTooltipStyle } from './tooltip-portal-comp.helpers';

import ToolTip from 'react-portal-tooltip';

import styles from './tooltip-portal-comp.module.scss';

type Props = {
  additionalStyles?: ModalPortalStyles;
  arrowPosition?: 'center' | 'right' | 'left' | 'top' | 'bottom' | null;
  isOpen: boolean;
  parentNode?: HTMLElement | null | undefined;
  parentSelector?: string;
  positionToContainer?: 'left' | 'top' | 'right' | 'bottom';
  text: string;
  timeoutOverride?: number;
  toolTipAlignment?: 'center' | 'right' | 'left';
  toolTipGroup?: string;
};

export const ToolTipPortalComp = ({
  additionalStyles,
  arrowPosition = null, // when null shows no arrow
  isOpen,
  parentNode,
  parentSelector,
  positionToContainer = 'right',
  text,
  timeoutOverride = 500,
  toolTipAlignment = 'center',
  toolTipGroup,
}: Props) => {
  const darkMode = useDarkMode(false, {
    element: document.documentElement,
  });

  if (!parentSelector && !parentNode) return null;

  return (
    <ToolTip
      active={isOpen}
      arrow={arrowPosition}
      align={toolTipAlignment}
      group={toolTipGroup}
      parent={parentSelector || parentNode}
      position={positionToContainer}
      style={{ ...getTooltipStyle(additionalStyles || {}, darkMode.value) }}
      tooltipTimeout={timeoutOverride}
    >
      <p className={styles.text}>{text}</p>
    </ToolTip>
  );
};
ToolTipPortalComp.displayName = 'ToolTipPortalComp';
export default ToolTipPortalComp;
